import { useState } from 'react';
import { PageInfo } from '@lgg/isomorphic/types/__generated__/graphql';
import { TableProps } from 'src/components/general/display/table';
import {
  getSortDirectionByOrder,
  SorterData,
  TableSortData,
} from 'src/components/general/table-helpers';

const PAGE_SIZE = 25;
const DEFAULT_SORT_DATA: TableSortData = { key: 'createdAt', direction: 'DESC' };

type Pagination = { first: number; after?: string } | { last: number; before: string };

const FIRST_PAGE: Pagination = { first: PAGE_SIZE };

export const useKnowledgeSourceListState = <T>() => {
  const [sortData, setSortData] = useState<TableSortData>(DEFAULT_SORT_DATA);
  const [pagination, setPagination] = useState<Pagination>(FIRST_PAGE);

  const onTableChange: TableProps<T>['onChange'] = (_pagination, _filters, sorter) => {
    const { columnKey, order } = sorter as SorterData<T>;
    const direction = getSortDirectionByOrder(order);

    setPagination(FIRST_PAGE);
    setSortData(direction ? { key: columnKey, direction } : DEFAULT_SORT_DATA);
  };

  const getPaginationProps = (
    pageInfo: Pick<
      PageInfo,
      'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'
    >,
  ) => ({
    hasPreviousPage: pageInfo.hasPreviousPage,
    hasNextPage: pageInfo.hasNextPage,
    onLoadPreviousPage: () => {
      if (pageInfo.startCursor) {
        setPagination({ last: PAGE_SIZE, before: pageInfo.startCursor });
      }
    },
    onLoadNextPage: () => {
      if (pageInfo.endCursor) {
        setPagination({ first: PAGE_SIZE, after: pageInfo.endCursor });
      }
    },
  });

  return {
    sortData,
    listVariables: { ...pagination, orderBy: { [sortData.key]: sortData.direction } },
    onTableChange,
    getPaginationProps,
  };
};
